import FeatureGates from '@atlaskit/feature-gate-js-client';
import { useGetExperimentValue } from '@trello/feature-gate-client';

export const useIsReverseTrialEnabled = () => {
  const { cohort } = useGetExperimentValue({
    experimentName: 'trello_enterprise_reverse_trials',
    parameter: 'cohort',
    fireExposureEvent: false,
  });
  return cohort === 'experiment';
};

export const isReverseTrialEnabled = () => {
  const cohort = FeatureGates.getExperimentValue<
    'control' | 'experiment' | 'not-enrolled'
  >('trello_enterprise_reverse_trials', 'cohort', 'not-enrolled');
  return cohort === 'experiment';
};
